







































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import PdMonitorChart from "../../chart.vue";
import DynamicColumnSelect from "../../dynamicColumnSelect.vue";
import {
  QueryPdMonitorAdequacyChartData,
  GetPdAssessAdquacyListForMonitor
} from "@/api/pdOutPatient/pdComprehensiveEvaluation/pdAssessAdequacy";
@Component({
  components: {
    PdMonitorChart,
    DynamicColumnSelect
  }
})
export default class PdMonitorAdequacy extends AbpBase {
  @Prop() patient: any;
  currentType: string = "0";
  chartData: any = null;
  showDyanmicColumnSelect: boolean = false;
  selectedColumns: any = [];
  data: any = [];
  buttons: any = [
    {
      type: "0",
      buttonText: "透析液（入/出/超滤量）",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "1",
      buttonText: "体内总水量",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "2",
      buttonText: "标准体重",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "3",
      buttonText: "体表面积",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "4",
      buttonText: "Kt/v（总/腹膜/残肾）",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "5",
      buttonText: "Ccr（总/腹膜/残肾）",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "6",
      buttonText: "排钠（尿液/透析液）",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "7",
      buttonText: "排钙（尿液/透析液）",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "8",
      buttonText: "排钾（尿液/透析液）",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "9",
      buttonText: "排磷（尿液/透析液）",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "10",
      buttonText: "UNA",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "11",
      buttonText: "nPNA",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "12",
      buttonText: "蛋白丢失",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "13",
      buttonText: "单位体重蛋白丢失",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    }
  ];

  columns = [
    {
      title: "透析液（入/出/超滤量）",
      key: "txy",
      width: 220
    },
    {
      title: "体内总水量",
      key: "tnzsl",
      width: 120
    },
    {
      title: "标准体重",
      key: "bztz",
      width: 100
    },
    {
      title: "体表面积",
      key: "tbmj",
      width: 100
    },
    {
      title: "Kt/v（总/腹膜/残肾）",
      key: "ktv",
      width: 200
    },
    {
      title: "Ccr（总/腹膜/残肾）",
      key: "ccr",
      width: 200
    },
    {
      title: "排钠（尿液/透析液）",
      key: "na",
      width: 200
    },
    {
      title: "排钙（尿液/透析液）",
      key: "ca",
      width: 200
    },
    {
      title: "排钾（尿液/透析液）",
      key: "ka",
      width: 200
    },
    {
      title: "排磷（尿液/透析液）",
      key: "p",
      width: 200
    },
    {
      title: "UNA",
      key: "una",
      width: 100
    },
    {
      title: "nPNA",
      key: "npna",
      width: 100
    },
    {
      title: "蛋白丢失",
      key: "dbds",
      width: 100
    },
    {
      title: "单位体重蛋白丢失",
      key: "dwtzdbds",
      width: 180
    }
  ];

  @Watch("patient", { immediate: true, deep: true })
  onPatientChanged() {
    this.selectedColumns = JSON.parse(JSON.stringify(this.columns)); //此处用数组拷贝的方式会出现错误“You may have an infinite update loop in watcher with expression "columns"”，故采用json序列化的方式拷贝数组，且render函数无效，需另外编写api数据接口
    this.insertAssessTime();
    if (this.patient.pD_Patient_ID) {
      this.handleClick("0");
      this.getData();
    }
  }

  //在第一列前面插入评估日期
  insertAssessTime() {
    this.selectedColumns.splice(0, 0, {
      title: "日期",
      key: "assessTime",
      minWidth: 120,
      render: (h: any, p: any) => {
        return h("div", {}, this.formatDate(p.row.assessTime));
      }
    });
  }

  async getData() {
    let res = await GetPdAssessAdquacyListForMonitor(
      this.patient.pD_Patient_ID
    );
    this.data = res.objects;
  }

  async handleClick(type: string) {
    this.currentType = type;
    let payload = {
      pD_Patient_ID: this.patient.pD_Patient_ID,
      type: type
    };
    let res = await QueryPdMonitorAdequacyChartData(payload);
    this.chartData = res.objects;
  }

  handleDyanmicColumnSelectOk() {
    let res = this.$refs.DynamicColumnSelect.onSubmit();
    this.selectedColumns = JSON.parse(JSON.stringify(res));
    this.insertAssessTime();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdMonitor/pdMonitorIndex/parts/pdMonitorAdequacy/index.vue